import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducer';
import { createLogger } from 'redux-logger';
import { SagaMiddleware } from 'redux-saga';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './rootSaga';

const sagaMiddleware: SagaMiddleware = createSagaMiddleware();

const logger = createLogger({
  collapsed: true,
  predicate: (getState, action) => action.type !== 'PLAYER_TURN',
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger, sagaMiddleware),
});

sagaMiddleware.run(rootSaga);
